import { render, staticRenderFns } from "./MapGetArea.vue?vue&type=template&id=21fb1b62&scoped=true&"
import script from "./MapGetArea.vue?vue&type=script&lang=js&"
export * from "./MapGetArea.vue?vue&type=script&lang=js&"
import style0 from "./MapGetArea.vue?vue&type=style&index=0&id=21fb1b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb1b62",
  null
  
)

export default component.exports